import React from 'react';
import Menu from '../Menu.component';
import { menuItemPropType } from '../MenuItem.component';

var InlineMenu = function InlineMenu(_ref) {
  var items = _ref.items;
  return /*#__PURE__*/React.createElement(Menu, {
    block: "inline-menu",
    items: items
  });
};

export default InlineMenu;